module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-market-update-modal"
  }, [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "version check"
    }
  }, [_vm._v("Meteo-Parapente requires an update.")])], 1), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.versions.installed) + " "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  }), _vm._v(" " + _vm._s(_vm.versions.minimal))])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.openStore
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "version check"
    }
  }, [_vm._v("Install now")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a33e684"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/app-market-update.vue
// module id = 334
// module chunks = 1